import { createOidcConfig, loadStoredUser } from '@medcom/shared-ui/utils/oidc.ts';

export const oidcConfig = createOidcConfig(window._env_.KEYCLOAK_URL, 'befunde-ui');

export const loadUser = () => loadStoredUser(oidcConfig);
